import Tag from 'antd/lib/tag'
import './index.less'

export default Tag



// WEBPACK FOOTER //
// ./src/elements/tag/index.js